<nz-modal [nzTitle]="title" [(nzVisible)]="visible" (nzOnCancel)="close()" [nzWidth]="700" [nzMaskClosable]="false">
  <ng-container *nzModalContent>
    <form [formGroup]="form">
      <nz-form-item>
        <nz-form-label>审核意见</nz-form-label>
        <nz-form-control>
          <nz-textarea-count [nzMaxCharacterCount]="255">
            <textarea rows="8" placeholder="请输入" formControlName="remark" nz-input></textarea>
          </nz-textarea-count>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
  <div *nzModalFooter>
    <div style="text-align: center">
      <button style="width: 120px; margin-right: 30px" nz-button nzType="primary" [nzLoading]="loading" (click)="submit(true)">通过</button>
      <button style="width: 120px; margin-right: 30px" nz-button nzType="primary" [nzLoading]="loading" (click)="submit(false)">
        驳回
      </button>
      <button style="width: 120px" nz-button nzType="default" (click)="close()">取消</button>
    </div>
  </div>
</nz-modal>
